("use client");

import './App.css';
import { GetData } from './utils/getData';
import { GoButton } from './utils/inputBoxes';
import { DataGrid, GetDGLoadingError } from './utils/dataGrid';
import { initializeDBValues, maintainValue, UploadButton } from './utils/maintainDBValues';


import {
  AllCommunityModule,
  ModuleRegistry,
} from "ag-grid-community";

import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { useCallback, useEffect, useRef, useState } from 'react';

ModuleRegistry.registerModules([AllCommunityModule]);

const client = new ApolloClient({
  link: new HttpLink({ uri: "http://graphql-kloomba.attainplatform-development.com/graphql" }), 
  cache: new InMemoryCache(),
});

function App() {
  const total = 5;
  const numInvalid = 3;
  const brandFilter = "";
  const [countCorrect, setCountCorrect] = useState(0);
  const [rowData, setRowData] = useState([]);
  const { loading, error, data, refetch } = GetData(total, numInvalid);
  const gridRef = useRef(null);

  let allInput = GoButton(total, numInvalid, brandFilter, refetch);

  const onCheckboxChange = useCallback((rowData, newValue) => {
    maintainValue(rowData, newValue);
    newValue ? setCountCorrect(countCorrect + 1) : setCountCorrect(countCorrect - 1);
  }, [countCorrect]);

  var curGrid = DataGrid(rowData, onCheckboxChange, gridRef);

  useEffect(() => {
    if (data && data.RandomRecs && data.RandomRecs.recs) {
      initializeDBValues(data.RandomRecs.recs);
      setRowData(data.RandomRecs.recs);
    }
  }, [data]);

  return (<div style={{ height: '100%', width: '100%' }}>
    <p class="navbar-fixed-top">Kloomba Turing Test</p>
    <div class='Ag-grid-loc' style={{ height: 'calc(100% - 150px)', width: '100%', paddingTop: '45px' }}>
      {
        (loading || error) ? GetDGLoadingError(loading, error) : curGrid
      };
    </div>
    <div class="container">
      <div class="left-aligned">
        <span>
          <label class="label-for-number" for="number"># Recs:</label>
          {allInput.numRecs}
        </span>
        <span>
          <label class="label-for-invalid" for="number"># Invalid:</label>
          {allInput.numInvalid}
        </span>
        <span>
          <label class="label-for-filter" for="text">Filter:</label>
          {allInput.filter}
        </span>
        <span>
          {allInput.goButton}
        </span>
         <span>
          {UploadButton()}
        </span>
      </div>
      <span class="right-aligned">
        {"Percent correct = " + Math.round(countCorrect / total * 100, 2) + "%"}
      </span>
    </div>
  </div>)
}

export default App;
